import { Reveal } from "./motion";

export const Manifesto = ({ overline, title, subtitle, chapters }) => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-28 lg:py-40 bg-[#050505] border-y border-[#1c1c1c]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-[0.9fr_1.6fr] gap-16 lg:gap-24">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <Reveal>
            <p className="text-xs tracking-[0.3em] uppercase text-[#fcc41b] font-display font-medium mb-6">{overline}</p>
            <h2 className="font-display font-semibold tracking-tighter leading-[0.95] text-white" style={{ fontSize: "clamp(2.25rem, 5vw, 4rem)" }}>
              {title}
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-sm">{subtitle}</p>
          </Reveal>
        </div>

        <div className="flex flex-col">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={0.05}>
              <div className={`py-10 lg:py-14 grid grid-cols-[auto_1fr] gap-6 lg:gap-10 ${i !== 0 ? "border-t border-[#1c1c1c]" : ""}`}>
                <span className="font-display font-light text-4xl lg:text-6xl text-[#fcc41b]/80 leading-none">{c.n}</span>
                <div>
                  <h3 className="font-display font-semibold text-2xl lg:text-4xl text-white mb-4">{c.title}</h3>
                  <p className="text-zinc-400 text-lg leading-relaxed max-w-xl">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
